import './index.css';
import { useContext, useMemo } from 'react';
import { BreakpointContext, Breakpoint } from './BreakpointProvider.js';
import 'react/jsx-runtime';
import '@hh.ru/magritte-common-cookies';
import '@hh.ru/magritte-common-resize';

const useBreakpoint = () => {
    const { breakpoint } = useContext(BreakpointContext);
    const breakpointMap = useMemo(() => ({
        isXS: breakpoint === Breakpoint.XS,
        isS: breakpoint === Breakpoint.S,
        isM: breakpoint === Breakpoint.M,
        isL: breakpoint === Breakpoint.L,
        isXL: breakpoint === Breakpoint.XL,
        isXXL: breakpoint === Breakpoint.XXL,
        isMobile: [Breakpoint.XS, Breakpoint.S].includes(breakpoint),
        isGtXS: [Breakpoint.S, Breakpoint.M, Breakpoint.L, Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
        isGtS: [Breakpoint.M, Breakpoint.L, Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
        isGtM: [Breakpoint.L, Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
        isGtL: [Breakpoint.XL, Breakpoint.XXL].includes(breakpoint),
        breakpoint,
    }), [breakpoint]);
    return breakpointMap;
};

export { useBreakpoint as default };
//# sourceMappingURL=useBreakpoint.js.map
